import {
    TextContainer,
    InnerRow,
    RemoveButton,
    MessageText,
    StyledList,
    Row,
    UnreadIndicatorContainer,
    TimeText
} from './styles.gl2025';
import { createElement as rc, useContext } from 'react';
import { useTheme } from 'styled-components';
import useEventSink from '../../hooks/useEventSink';
import TimeAgo from '../TimeAgo';
import { contexts, Badge } from 'lib_ui-primitives';

const _p = {
    useEventSink
};
export const _private = _p;
const RowDetail = props => {
    const { item, onClick, recoverFocus } = props;
    const [, publish] = _p.useEventSink();
    const session = useContext(contexts.SessionContext);
    const theme = useTheme();

    const onRemoveClick = () => {
        // We cannot stop propagation here because the Menu needs to know that a click happened inside it.
        // If we do, the menu thinks an outside click happened (or doesn't realize focus shifted) and enters a "zombie" state.
        // By calling recoverFocus(), we move focus to a stable element (header filter button) before this row disappears.
        // This ensures the menu knows focus is still "inside" it.
        recoverFocus?.();

        // Delay the publish call to ensure the menu processes the click and focus transition before the row is removed.
        setTimeout(() => {
            publish(
                {
                    id: item._id,
                    meta: {
                        deleted: true,
                        deletedBy: { _id: session?.profile?.userId, name: session?.profile?.displayName },
                        deletedTime: new Date().toISOString()
                    }
                },
                {
                    verb: 'remove',
                    namespace: 'application',
                    relation: 'notification'
                }
            );
        }, 0);
    };

    const onShowSelectedNotification = e => {
        // Check if the click originated from the remove button (or its children like the icon)
        // If it did, we don't want to trigger the notification selection.
        // On native, e.target.closest is not available, but inner Pressables catch the event.
        if (!theme.mobile && typeof e?.target?.closest === 'function' && e.target.closest('.remove-button')) {
            return;
        }
        onClick(item);
    };

    return rc(
        Row,
        { ...(theme.mobile ? { onPress: onShowSelectedNotification } : { onClick: onShowSelectedNotification }) },
        rc(
            InnerRow,
            null,
            rc(
                UnreadIndicatorContainer,
                null,
                item.seen !== true &&
                    rc(Badge, {
                        badge: item.variant === 'error' ? 'error' : 'info',
                        size: theme.notifications.unreadIndicator.size
                    })
            ),
            rc(
                TextContainer,
                null,
                rc(MessageText, null, item.message),
                rc(TimeText, { as: TimeAgo, date: item.meta?.createdTime })
            ),
            rc(RemoveButton, {
                variant: 'tertiary',
                icon: 'trash-2',
                onClick: onRemoveClick
            })
        )
    );
};

export default function NotificationListGL2025(props) {
    const { notifications, onShowSelectedNotification, recoverFocus } = props;
    return rc(
        StyledList,
        null,
        notifications.map((n, i) =>
            rc(RowDetail, { key: n._id || i, item: n, onClick: onShowSelectedNotification, recoverFocus })
        )
    );
}
